import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
Vue.use(Vuex);
import moduleAuth from "./modules/auth.js";
import moduleVehicle from "./modules/vehicles";
import moduleDriver from "./modules/drivers";
import moduleCompany from "./modules/company";
import moduleEld from "./modules/eld";
import moduleEvent from "./modules/events";
import moduleLog from "./modules/logs";
import reports from "./modules/reports";
import fmcsaReports from "./modules/fmcsa-reports.js";
import activityReports from "./modules/activityReports.js";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    vehicle: moduleVehicle,
    driver: moduleDriver,
    company: moduleCompany,
    auth: moduleAuth,
    eld: moduleEld,
    event: moduleEvent,
    log: moduleLog,
    reports: reports,
    fmcsaReports: fmcsaReports,
    activityReports: activityReports,
  },
  strict: process.env.NODE_ENV !== "production",
});
